export function joinMultipleStyle(
    defaultStyle: string,
    additionalStyle?: string
): string {
    if (additionalStyle) return `${defaultStyle} ${additionalStyle}`;
    else return defaultStyle;
}
